import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from "./theme/theme";
import LoginPage from "./features/auth/pages/LoginPage";
import store from "./store/store";
import { Provider } from "react-redux";
import ForgotPasswordPage from "./features/auth/pages/ForgotPasswordPage";
import ResetPasswordPage from "./features/auth/pages/ResetPasswordPage";
import ConfirmationPage from "./features/auth/pages/ConfirmationPage";
import { manifestRoutes } from "./features/manifests";
import { PageLoading } from "./shared/kit";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Suspense fallback={<PageLoading />}>
        <Routes>
        {/* auth routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/resetPassword/:acessToken" element={<ResetPasswordPage />} />

        {/* The 7 capability modules (features/modules.jsx): People, Conversations,
            Commerce, Farm Ops, Programs, Insights, Platform Admin. Every route keeps
            its pre-module URL. */}
        {manifestRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Routes>
      </Suspense>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
